/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import { Box, Checkbox, Chip, Divider, FormControlLabel, Input, TextField } from '@material-ui/core';
import React, { useState, useMemo } from 'react';
import MultiSelect from '../../../../components/MultiSelect';
import { Search } from '@material-ui/icons';
import { LocalizationProvider, MobileDatePicker } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterMoment';
import * as moment from 'moment';

const selectOptions = [
  {
    label: 'Formations',
    data: ['Formation 1', 'Formation 2']
  },
  {
    label: 'Status',
    data: ['Status 1', 'Status 2']
  },
  {
    label: 'Professions',
    data: ['Profession 1', 'Profession 2']
  },
];

const CustomRepportDetailsOptionsBar = ({ setFilters }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [inputValue, setInputValue] = useState('');
  const [chips, setChips] = useState([]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyup = (event) => {
    if (event.code === 'Enter' && inputValue) {
      if (!chips.includes(inputValue)) {
        setChips((prevChips) => [...prevChips, inputValue]);
        setInputValue('');
        setFilters((prevChips) => [...prevChips, inputValue]);
      }
    }
  };

  const handleChipDelete = (chip) => {
    setChips((prevChips) => prevChips.filter((prevChip) => chip !== prevChip));
    setFilters((prevChips) => prevChips.filter((prevChip) => chip !== prevChip));
  };

  const handleMultiSelectChange = (value) => {
    setChips(value);
    setFilters(value);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
        minHeight: '100%',
        p: 3
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          p: 2
        }}
      >
        <Search fontSize="small" />
        <Box
          sx={{
            flexGrow: 1,
            ml: 3
          }}
        >
          <Input
            disableUnderline
            fullWidth
            placeholder="Entrer une recherche"
          />
        </Box>
      </Box>
      <Divider />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          p: 2
        }}
      >
        {chips.map((chip) => (
          <Chip
            key={chip}
            label={chip}
            onDelete={() => handleChipDelete(chip)}
            sx={{ m: 1 }}
            variant="outlined"
          />
        ))}
      </Box>
      <Divider />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          p: 1
        }}
      >
        <Box
          sx={{
            display: 'flex',
            mt: 4
          }}
        >
          <LocalizationProvider
            dateAdapter={DateAdapter}
            locale={moment.locale('fr')}
          >
            <Box sx={{ mr: 2 }}>
              <MobileDatePicker
                size="small"
                label="Période du"
                onChange={(newDate) => setStartDate(newDate)}
                renderInput={(inputProps) => (
                  <TextField
                    {...inputProps}
                    size="small"
                  />
                )}
                value={startDate}
              />
            </Box>
            <Box sx={{ mr: 2 }}>
              <MobileDatePicker
                size="small"
                label="au"
                onChange={(newDate) => setEndDate(newDate)}
                renderInput={(inputProps) => (
                  <TextField
                    {...inputProps}
                    size="small"
                  />
                )}
                value={endDate}
              />
            </Box>
          </LocalizationProvider>

          {selectOptions.map((option) => (
            <MultiSelect
              key={option.label}
              label={option.label}
              onChange={handleMultiSelectChange}
              options={option.data}
              value={chips}
            />
          ))}

          {/* <MultiSelect
            label="Formations"
            options={formationsList}
            value={formationsValues}
          />

          <MultiSelect
            label="Professions"
            options={professionsList}
            value={professionsValues}
          /> */}
        </Box>
        <Box sx={{ flexGrow: 1 }} />
      </Box>
    </Box>
  );
};

export default CustomRepportDetailsOptionsBar;
